import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RolesPermisosService } from '../roles-y-permisos.service';
import { UtilsService } from 'app/modules/utils-service';
import { Router } from '@angular/router';

@Component({
    selector: 'agregar-rol',
    templateUrl: 'form-agregar-rol.component.html',
    imports:[
        CommonModule,
        MatFormFieldModule,
        MatButtonModule,
        MatInputModule,
        FormsModule

    ]
})

export class FormRolComponent implements OnInit {
    nombreRol:string

    constructor(
        public dialogRef: MatDialogRef<FormRolComponent>,
        private _rolesPermisosService:RolesPermisosService,
        private _utilsService:UtilsService,
        private _router: Router
    ) { }

    ngOnInit() { }

    guardarRol(rol:string){
        let body={nombreRol:rol}
        this._rolesPermisosService.postRol(body)
        .then((response:any)=>{
            this._utilsService.openSuccessSnakBar(response.message)
            this.dialogRef.close(false)
            this._router.navigateByUrl(`/roles-y-permisos/rol/${response.data.rol}`)
        })
    }
}